import styled from 'styled-components';

import { spacing } from 'styles/theme';

export const SubtotalLineBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: ${spacing('small')};
`;
